import React, { useEffect, useMemo } from "react";
import {
  Box,
  Text,
  InputGroup,
  InputLeftElement,
  Input,
  SimpleGrid,
  Spinner,
} from "@chakra-ui/react";
import { BiSearch } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import PaginatedLoans from "../components/PaginatedLoans";
import { useDispatch, useSelector } from "react-redux";
import { getLoanRequestAction } from "../redux/reducers/loanRequestReducer";

const VerificationPage = () => {
  const dispatch = useDispatch();

  const { loans, meta, loading } = useSelector((state) => state.loanRequest);

  let filters = useMemo(
    () => ({
      page: 1,
      pageLimit: 50,
    }),
    []
  );

  const role = localStorage.getItem("role");
  const navigate = useNavigate();
  useEffect(() => {
    if (!role) navigate("/");
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(getLoanRequestAction(filters));
  }, [dispatch, filters]);

  return (
    <Box
      bg="#F8F9FC"
      p={["20px 10px", "20px 10px", "20px 10px 20px 30px"]}
      h="100vh"
      w="100%"
    >
      <Text
        color="#5B2E4F"
        fontSize="18px"
        fontWeight="500"
        fontFamily="satoshiBold"
      >
        Loans Awaiting Verification
      </Text>

      <Box mt="20px">
        <SimpleGrid
          spacing="20px"
          columns={[2, 2, 4, 4]}
          justify="space-between"
          mt="10px"
          p={["25px 10px", "25px 15px", "25px"]}
          bg="#FFFFFF"
          maxWidth="100%"
        >
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <BiSearch size="20px" color="#666666" />
            </InputLeftElement>
            <Input
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  dispatch(
                    getLoanRequestAction({
                      ...filters,
                      searchQuery: e.target.value,
                    })
                  );
                }
              }}
              border="1px solid #E4E8F2"
              fontSize="13px"
              fontFamily="satoshiBold"
              color="#666666"
              type="tel"
              placeholder="Search name or enter keyword"
            />
          </InputGroup>
        </SimpleGrid>

        {loading && (
          <Box
            display={"flex"}
            justify={"center"}
            alignItems={"center"}
            justifyContent={"center"}
            marginTop={"20"}
          >
            <Spinner size="xl" />
          </Box>
        )}

        <PaginatedLoans loans={loans} meta={meta} />

        {!loading && loans.length === 0 && (
          <Box
            display={"flex"}
            justify={"center"}
            alignItems={"center"}
            justifyContent={"center"}
            marginTop={"20"}
          >
            <Text>No loans awaiting verification</Text>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default VerificationPage;
